(() => {
  if (customElements.get('tj-sticky-atc')) return;

  class TJStickyAtc extends HTMLElement {
    connectedCallback() {
      this.submitButton = this.querySelector('[data-sticky-atc-submit]');
      this.label = this.querySelector('[data-sticky-atc-label]');
      this.price = this.querySelector('[data-sticky-atc-price]');
      this.boundUpdate = this.update.bind(this);
      this.boundSync = this.sync.bind(this);
      window.addEventListener('scroll', this.boundUpdate, { passive: true });
      window.addEventListener('resize', this.boundUpdate, { passive: true });
      document.addEventListener('product-info:loaded', this.boundSync);
      this.observer = new MutationObserver((mutations) => {
        if (mutations.every((mutation) => this.contains(mutation.target))) return;
        this.sync();
      });
      const owner = this.productInfo;
      if (owner) this.observer.observe(owner, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.boundUpdate);
      window.removeEventListener('resize', this.boundUpdate);
      document.removeEventListener('product-info:loaded', this.boundSync);
      this.observer?.disconnect();
      document.body?.classList.remove('tj-sticky-atc-visible');
    }

    get productInfo() {
      return this.closest('.shopify-section')?.querySelector('product-info') || document.querySelector('product-info');
    }

    get nativeButton() {
      return document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
    }

    get nativePrice() {
      return document.getElementById(`price-${this.dataset.sectionId}`);
    }

    sync() {
      const nativeButton = this.nativeButton;
      if (!nativeButton || !this.submitButton) {
        this.setVisible(false);
        return;
      }
      const nativeLabel = nativeButton.querySelector('span');
      if (nativeLabel && this.label) this.label.textContent = nativeLabel.textContent.trim();
      this.submitButton.disabled = nativeButton.disabled;
      this.submitButton.setAttribute('aria-disabled', String(nativeButton.disabled));

      const priceRoot = this.nativePrice;
      const priceContainer = priceRoot?.querySelector('.price');
      const selector = priceContainer?.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular';
      const currentPrice = priceRoot?.querySelector(selector);
      if (currentPrice && this.price) this.price.textContent = currentPrice.textContent.trim();
      this.update();
    }

    update() {
      const nativeButton = this.nativeButton;
      if (!nativeButton) {
        this.setVisible(false);
        return;
      }
      const stickyHeader = document.querySelector('.section-header.shopify-section-header-sticky');
      const headerBottom = stickyHeader?.getBoundingClientRect().bottom || 0;
      this.setVisible(nativeButton.getBoundingClientRect().bottom <= headerBottom);
    }

    setVisible(visible) {
      this.hidden = !visible;
      this.classList.toggle('is-visible', visible);
      document.body?.classList.toggle('tj-sticky-atc-visible', visible);
    }
  }

  customElements.define('tj-sticky-atc', TJStickyAtc);
})();
